import CardProfile from 'components/CardProfile';
import Layout from 'Layout'
import React, { useCallback } from 'react'
import cx from 'classnames'
import { useNavigate, useParams } from 'react-router-dom';
import { getPerangkatDesa } from 'services/apiRoutes';
import { useState } from 'react';
import { useEffect } from 'react';
import SkeletonCardProfile from 'skeletons/SkeletonCardProfile';

export default function Perangkat() {
  const {slug}=useParams()
  const navigate = useNavigate();
  const [perangkat,setPerangkat]= useState();
  const [loading,setLoading]=useState(false);

  const perangkatAPI = useCallback(async()=>{
    setLoading(true);
    const res = await getPerangkatDesa(slug);
    if (res.error) {
        return res.message;
    }else{
      const {data} = res.data;
      setPerangkat(data);
      setLoading(false);
    }
  },[slug])


  useEffect(() => {
    perangkatAPI();
  }, [perangkatAPI]);

   const elipseClasses = cx({
    'absolute  rounded-full shadow -z-[1] top-1/3  w-[130px] h-[130px] ': true,
  });
  return (
    <Layout>
      <div className="px-5 pt-28 xl:pt-44 kegiatan-wrapper xl:px-99">
        <h1 className="text-2xl font-bold mb-14 xl:text-7xl xl:mb-32">
          Perangkat Gampong
        </h1>
        <div className="w-full space-y-5 xl:space-y-0 inner xl:flex xl:space-x-5">
          {!perangkat ? (
            <SkeletonCardProfile />
          ) : (
            <CardProfile
              nama={perangkat ? perangkat[0]?.nama : ""}
              jabatan={perangkat ? perangkat[0]?.jabatan_obj?.nama : ""}
              hp={perangkat ? perangkat[0]?.telepon : ""}
              email={perangkat ? perangkat[0]?.email : ""}
              profileImage={perangkat ? perangkat[0]?.url_gambar : ""}
              onClick={() => navigate("/postperangkat/1")}
            />
          )}
          <div className="px-16 relative py-5 bg-transparent z-0 xl:flex justify-center xl:border-none border items-center xl:w-[70%] sambutanWrapper rounded-2xl border-borderCardFeatures">
            <div
              className={`left-0 greenElipse ml-28 rounded-3xl ${elipseClasses}`}
            />
            <div className={`right-0  orangeElipse mr-28 ${elipseClasses}`} />
            <p className="leading-7 xl:border xl:py-3 xl:px-5 md:text-3xl text-nameColor xl:bg-wrapperBlur rounded-2xl border-blurBorder">
              {perangkat ? perangkat[0]?.deskripsi : ""}
            </p>
          </div>
        </div>
        <div className="justify-between my-20 space-y-5 xl:flex xl:space-y-0">
          {!loading
            ? perangkat?.map(
                (item, index) =>
                  index !== 0 && (
                    <CardProfile
                      nama={item?.nama}
                      jabatan={item?.jabatan_obj?.nama}
                      hp={item?.telepon}
                      email={item?.email}
                      profileImage={item?.url_gambar}
                      // onClick={() => navigate("/postperangkat/2")}
                    />
                  )
              )
            : [1, 2, 3].map((item) => <SkeletonCardProfile key={item} />)}
        </div>
      </div>
    </Layout>
  );
}
